var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getJobDetails } from '@/api';
import { Button } from '@/components';
import { useQuery } from '@/hooks/use-query';
import React, { useCallback } from 'react';
var JobDetailsContexts = React.createContext(null);
export var JobDetailsProvider = function (_a) {
    var children = _a.children;
    var isValidRoute = /^\/job\/\d+\/[^/]+\/?$/.test(new URL(window.location.href).pathname);
    var jobId = isValidRoute ? window.location.pathname.split('/')[2] || '' : '';
    var getJobDetailsQuery = useCallback(function () {
        return getJobDetails(+jobId);
    }, [jobId]);
    var _b = useQuery({
        queryFn: getJobDetailsQuery,
        config: {
            enabled: !!+jobId,
        },
    }), jobDetails = _b.data, isLoading = _b.isLoading, refetchJobDetails = _b.refetch, setJobDetails = _b.setData;
    var updateJobDetails = useCallback(function (jobPayload) {
        setJobDetails(function (prev) {
            if (!prev)
                return prev;
            return __assign(__assign({}, prev), jobPayload);
        });
    }, [setJobDetails]);
    if (!isValidRoute) {
        return (_jsx("div", { className: 'flex items-center justify-center min-h-screen', children: _jsxs("div", { className: 'bg-white shadow-md rounded p-6 text-center', children: [_jsx("h2", { className: 'text-2xl font-bold', children: "Invalid Route" }), _jsx("p", { className: 'mt-2', children: "The current route is invalid. Please use the following format:" }), _jsx("code", { className: 'block mt-2 bg-gray-100 p-2 rounded', children: "/job/:jobId/:slug" }), _jsx("div", { className: 'mt-4', children: _jsx(Button, { variant: 'primary', onClick: function () { return (window.location.href = '/'); }, children: "Go to Homepage" }) })] }) }));
    }
    if (!jobDetails) {
        return null;
    }
    return (_jsx(JobDetailsContexts.Provider, { value: {
            jobDetails: jobDetails,
            isLoading: isLoading,
            refetchJobDetails: refetchJobDetails,
            updateJobDetails: updateJobDetails,
            jobId: +jobId,
        }, children: children }));
};
export var useJobDetails = function () {
    var context = React.useContext(JobDetailsContexts);
    if (!context) {
        throw new Error('useJobDetails must be used within a JobDetailsProvider');
    }
    return context;
};
